import { useDevicesStore } from './use-devices-store';
import { useEffect } from 'react';

export const useFetchDevices = () => {
  const { getGroupDevices } = useDevicesStore();

  useEffect(() => {
    const get = async () => {
      await getGroupDevices();
    };
    get();
  }, []);

  return { getDevices: getGroupDevices };
};
